var map = {
	"./avatar1.png": "cc1a",
	"./avatar2.png": "bcef",
	"./avatar3.png": "33d8",
	"./avatar4.png": "45ce",
	"./avatar5.png": "12c4",
	"./avatar6.png": "ed84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";